import axios from "axios";
function getToken() {
  return localStorage.getItem("token");
}

const getConfig = () => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`
    },
    validateStatus: function (status) {
      return status >= 200 && status < 500;
    }
  };
  return config;
};

export default class ApiFetcher {
  findAll(model) {
    return axios.get(`/api/${model}`, getConfig());
  }

  find(model, id) {
    return axios.get(`/api/${model}/${id}`, getConfig());
  }

  create(model, data) {
    return axios.post(`/api/${model}`, data, getConfig());
  }

  update(model, data, id) {
    return axios.put(`/api/${model}/${id}`, data, getConfig());
  }


  makeRequest(method, url, data = {}, headers) {
    const config = getConfig();

    return axios({
      method: method.toLowerCase(),
      url: `${url}`,
      data: data,
      headers: config.headers,
      validateStatus: config.validateStatus
    });
  }

  post(url, data) {
    return axios.post(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/utils/ApiFetcher.js